var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-tab-item', {
    staticClass: "fill-height pa-16",
    attrs: {
      "value": _vm.thisTab
    }
  }, [_c('v-layout', {
    staticClass: "h-100 mx-auto",
    staticStyle: {
      "max-width": "1224px"
    },
    attrs: {
      "column": "",
      "justify-center": "",
      "align-center": ""
    }
  }, [_c('v-sheet', {
    staticClass: "scroll-primary px-10",
    staticStyle: {
      "flex": "1 1 auto",
      "overflow-x": "hidden",
      "overflow-y": "auto"
    }
  }, [_c('v-card', {
    staticClass: "py-20",
    attrs: {
      "outlined": "",
      "flat": "",
      "tile": "",
      "width": "480px",
      "max-width": "90vw"
    }
  }, [_c('v-layout', {
    staticClass: "pt-16 px-16",
    attrs: {
      "justify-center": "",
      "align-center": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "size": "80",
      "color": "primary"
    }
  }, [_vm._v("mdi-check-circle")])], 1), _c('v-card-title', {
    staticClass: "d-flex justify-center"
  }, [_vm._v(" 모든 서명 완료 ")]), _c('v-card-text', {
    staticClass: "text-center"
  }, [_vm._v(" 서명 완료 문서와 진행 이력이 담긴 인증서가 "), _c('br'), _vm._v(" 이메일로 전송되었습니다. ")])], 1)], 1), _c('div', {
    staticClass: "v-btn-group flex-wrap my-12"
  }, [_c('v-btn', _vm._b({
    staticClass: "min-w-140px min-w-lg-160px",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('exit');
      }
    }
  }, 'v-btn', {
    loading: _vm.loading
  }, false), [_c('span', [_vm._v(" 확인 ")])])], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }